const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterSaveChanges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17662"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3922",
    d: "M0 0h20a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H0V0z",
    style: {
      fill: "#cbf4ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "check (7)",
    d: "m13.794 6-6.733 6.731L4 9.672",
    transform: "translate(3.5 3.5)",
    style: {
      fill: "none",
      stroke: "#00d2a3",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSaveChanges);
export default __webpack_public_path__ + "static/media/filterSaveChanges.abf846d813f7ec537b5b49e623ec5545.svg";
export { ForwardRef as ReactComponent };